import React from 'react';

interface UnverifiedFieldIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const UnverifiedFieldIcon: React.FC<UnverifiedFieldIconProps> = ({
  width = 18,
  height = 18,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.64939 15.3752H4.61221C4.18939 15.3752 3.82757 15.2248 3.52673 14.9239C3.22589 14.6231 3.07522 14.261 3.07471 13.8377V11.8005L1.59486 10.3014C1.45393 10.1477 1.34502 9.97806 1.26814 9.79253C1.19127 9.60701 1.15283 9.4179 1.15283 9.22519C1.15283 9.0325 1.19127 8.84364 1.26814 8.65863C1.34502 8.47361 1.45393 8.30372 1.59486 8.14895L3.07471 6.64988V4.6127C3.07471 4.18988 3.22538 3.82806 3.52673 3.52722C3.82808 3.22638 4.18991 3.07571 4.61221 3.0752H6.64939L8.14846 1.59535C8.30221 1.45441 8.4721 1.34551 8.65814 1.26863C8.84418 1.19176 9.03303 1.15332 9.22471 1.15332C9.41638 1.15332 9.60549 1.19176 9.79204 1.26863C9.97859 1.34551 10.1482 1.45441 10.301 1.59535L11.8 3.0752H13.8372C14.26 3.0752 14.6221 3.22587 14.9235 3.52722C15.2248 3.82857 15.3752 4.1904 15.3747 4.6127V6.64988L16.8545 8.14895C16.9955 8.3027 17.1044 8.47259 17.1813 8.65863C17.2581 8.84466 17.2966 9.03352 17.2966 9.22519C17.2966 9.41687 17.2581 9.60598 17.1813 9.79253C17.1044 9.97908 16.9955 10.1487 16.8545 10.3014L15.3747 11.8005V13.8377C15.3747 14.2605 15.2243 14.6226 14.9235 14.9239C14.6226 15.2253 14.2605 15.3757 13.8372 15.3752H11.8L10.301 16.855C10.1472 16.996 9.97757 17.1049 9.79204 17.1818C9.60652 17.2586 9.41741 17.2971 9.22471 17.2971C9.03201 17.2971 8.84315 17.2586 8.65814 17.1818C8.47313 17.1049 8.30323 16.996 8.14846 16.855L6.64939 15.3752Z"
        fill="#F04438"
      />
      <path
        d="M12 6L6 12M6 6L12 12"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnverifiedFieldIcon;
